import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { HighlightedText } from "../../../pages/Documentation/utils";

const DocSearchComp = ({ searchResults, handleDocSearch, searchQuery }) => {
  return (
    <Container className="">
      {searchResults.length > 0 ? (
        searchResults?.map((result, idx) => (
          <React.Fragment key={idx}>
            <Row>
              <Col>
                <h5 className="text-secondary">{result.section}</h5>
              </Col>
            </Row>
            {result.headings.length > 0 ? (
              result.headings?.map((heading, hIdx) => (
                <React.Fragment key={`${idx}-${hIdx}`}>
                  {heading?.subHeadings.length > 0 ? (
                    heading?.subHeadings?.map((subHeading, shIdx) => (
                      <Row
                        className="mb-4"
                        key={`${idx}-${hIdx}-${shIdx}`}
                        onClick={() =>
                          handleDocSearch({
                            ...subHeading,
                            section: result.section,
                            headingId: heading.id,
                          })
                        }
                      >
                        <Col
                          className="border rounded d-flex align-items-center p-2"
                          style={{
                            backgroundColor: "#e3f2fd",
                            cursor: "pointer",
                          }}
                        >
                          <i className="bi bi-list fs-3 me-2"></i>
                          <span className="me-auto">
                            ...{" "}
                            <a href="#" className="text-decoration-none">
                              {subHeading?.match ? (
                                // subHeading?.match?.length > 40
                                //   ? `${subHeading?.match.slice(0, 40)}...`
                                //   : subHeading?.match
                                <HighlightedText
                                  text={subHeading?.match}
                                  query={searchQuery}
                                />
                              ) : searchQuery?.length > 40 ? (
                                `${searchQuery.slice(0, 40)}...`
                              ) : (
                                searchQuery
                              )}
                            </a>
                            <br />
                            <small className="text-muted">
                              {subHeading.subHeading !== ""
                                ? subHeading.subHeading
                                : heading.heading}
                            </small>
                          </span>
                          <Button variant="light" className="border">
                            <i className="bi bi-arrow-left-short"></i>{" "}
                            {result.section}
                          </Button>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <Row
                      className="mb-4"
                      onClick={() =>
                        handleDocSearch({
                          ...heading,
                          section: result.section,
                          headingId: heading.id,
                        })
                      }
                    >
                      <Col
                        className="border rounded d-flex align-items-center p-2"
                        style={{
                          backgroundColor: "#e3f2fd",
                          cursor: "pointer",
                        }}
                      >
                        <i className="bi bi-list fs-3 me-2"></i>
                        <span className="me-auto">
                          ...{" "}
                          <a href="#" className="text-decoration-none">
                            {heading?.match ? (
                              // heading?.match?.length > 40
                              //   ? `${heading?.match.slice(0, 40)}...`
                              //   : heading?.match
                              <HighlightedText
                                text={heading?.match}
                                query={searchQuery}
                              />
                            ) : searchQuery?.length > 40 ? (
                              `${searchQuery.slice(0, 40)}...`
                            ) : (
                              searchQuery
                            )}
                          </a>
                          <br />
                          <small className="text-muted">
                            {heading.heading}
                          </small>
                        </span>
                        <Button variant="light" className="border">
                          <i className="bi bi-arrow-left-short"></i>{" "}
                          {result.section}
                        </Button>
                      </Col>
                    </Row>
                  )}
                </React.Fragment>
              ))
            ) : (
              <Row className="mb-4" onClick={() => handleDocSearch(result)}>
                <Col
                  className="border rounded d-flex align-items-center p-2 py-4"
                  style={{
                    backgroundColor: "#e3f2fd",
                    cursor: "pointer",
                  }}
                >
                  <i className="bi bi-list fs-3 me-2"></i>
                  <span className="me-auto">
                    ...{" "}
                    <a href="#" className="text-decoration-none">
                      {result?.match ? (
                        // result?.match?.length > 40
                        //   ? `${result?.match.slice(0, 40)}...`
                        //   : result?.match
                        <HighlightedText
                          text={result?.match}
                          query={searchQuery}
                        />
                      ) : searchQuery?.length > 40 ? (
                        `${searchQuery.slice(0, 40)}...`
                      ) : (
                        searchQuery
                      )}
                    </a>
                    <br />
                  </span>
                </Col>
              </Row>
            )}
          </React.Fragment>
        ))
      ) : (
        <>
          <Row>
            {/* <Col>
              <h5 className="text-secondary">Contents</h5>
            </Col> */}
          </Row>
          <div className="text-muted text-center">No recent searches</div>
        </>
      )}
    </Container>
  );
};

export default DocSearchComp;
